import React from 'react';
import { useTranslation } from 'react-i18next';
import { FolderPlusIcon, Squares2X2Icon } from '@heroicons/react/24/outline';
import CommonMenu from './CommonMenu';

const CategoryActionsMenu = ({ isOpen, onSelect, onClose }) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    const items = [
        {
            id: 'createGroup',
            label: t('categories.addGroup', 'Создать группу'),
            icon: <Squares2X2Icon className="w-5 h-5" />,
            onClick: () => {
                onSelect("createGroup");
                onClose();
            }
        },
        {
            id: 'createCategory',
            label: t('categories.addNew', 'Добавить категорию'),
            icon: <FolderPlusIcon className="w-5 h-5" />,
            onClick: () => {
                onSelect("createCategory");
                onClose();
            }
        }
    ];

    return <CommonMenu onClose={onClose} items={items} />;
};

export default CategoryActionsMenu; 